import type { ReactNode } from 'react';
import { IconSearch } from './Icons';

/** Filters sit in one row above the data, never beside or below it. */
export function FilterBar({
  children,
  onReset,
  hasFilters,
}: {
  children: ReactNode;
  onReset?: () => void;
  hasFilters?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-rule px-3 py-2.5">
      {children}
      {onReset && hasFilters && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={onReset}>
          Clear filters
        </button>
      )}
    </div>
  );
}

export function SearchInput({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
}) {
  return (
    <div className="relative min-w-[13rem] flex-1 sm:max-w-xs">
      <IconSearch className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-ink-3" />
      <input
        className="input pl-8"
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export function FilterSelect<T extends string>({
  value,
  onChange,
  options,
  placeholder,
  label,
}: {
  value: T | '';
  onChange: (v: T | '') => void;
  options: { value: T; label: string }[];
  placeholder: string;
  label: string;
}) {
  return (
    <select
      className="select h-[2.125rem] w-auto"
      value={value}
      aria-label={label}
      onChange={(e) => onChange(e.target.value as T | '')}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
